<template>
  <div style="display:flex;align-items: center;">
    <el-checkbox v-model="item.isCheck"></el-checkbox>
    <el-image style="width: 100px;margin-left: 0.1rem;" :src="item.imageUrl" :preview-src-list="srcList">
      <div slot="error" class="image-slot">暂无图片</div>
    </el-image>
    <div style="margin-left: 0.1rem;width: 4rem;">
      <p>{{item.resourceName}}</p>
      <p>{{item.word}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    item:{
      type:Object,
      default:()=>{return{}}
    },
    srcList:{
      type:Array,
      default:()=>{return []}
    }
  }
}
</script>

<style>

</style>